import { render } from "./Program.vue?vue&type=template&id=2033e9f0&scoped=true"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"

import "./Program.vue?vue&type=style&index=0&id=2033e9f0&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2033e9f0"]])

export default __exports__